<template>
  <div class="transfer-to-account">
    <div class="custom-title">
      <img
        v-if="bankNo"
        class="svg-icon"
        :src="getIconByCode(bankNo)"
        alt="bank-icon"
      >
      {{ bankShortName }}
    </div>

    <div class="note-title">{{ $t('Account Number') }}</div>
    <md-field>
      <md-input-item
        v-model="accountNo"
        maxlength="16"
        is-virtual-keyboard
        virtual-keyboard-vm="myNumberKeyBoard"
        :placeholder="$t('Enter Beneficiary Account Number') "
      />
      <md-number-keyboard
        ref="myNumberKeyBoard"
        type="professional"
        hide-dot
        :ok-text="$t('confirm')"
      />
    </md-field>
    <div class="error-message">{{ errorMessage }}</div>

    <div class="transfer-button">
      <md-button type="primary" @click="handleVerify">
        {{ $t('Verify') }}
      </md-button>
    </div>

    <!-- 控制支付loading -->
    <PayLoading :is-show="showLoading" />
  </div>
</template>

<script>
import { Button, InputItem, Field, CellItem, NumberKeyboard } from 'mand-mobile'
import PayLoading from '@/components/PayLoading'
import { getIconByCode } from '@flash/fin-logo'
import { tradeAccountVerify } from '@/api/transfer'
export default {
  name: 'TransferToAccount',
  components: {
    [CellItem.name]: CellItem,
    PayLoading,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [NumberKeyboard.name]: NumberKeyboard
  },
  data () {
    return {
      getIconByCode,
      errorMessage: '',
      accountNo: '', // 账号
      showLoading: false // 弹框
    }
  },

  computed: {
    bankNo () {
      return this.$route.query.bankNo || ''
    },
    bankShortName () {
      return this.$route.query.bankShortName || ''
    }
  },

  methods: {
    handleVerify () {
      if (!this.accountNo) {
        this.errorMessage = this.$t('Please enter the account number')
        return
      }
      this.showLoading = true
      tradeAccountVerify({
        accountNo: this.accountNo,
        bankNo: this.bankNo
      })
        .then((res) => {
          if (!res.accountName) {
            this.errorMessage = this.$t('No Account found, please recheck and retry.')
            return
          }
          this.$router.push({
            name: 'TransferToBankConfirmInformation',
            query: {
              accountNo: res.accountNo || '',
              bankNo: this.bankNo,
              bankShortName: this.bankShortName,
              accountName: res.accountName || ''
            }
          })
        })
        .catch((e) => {
          this.errorMessage = this.$t('No Account found, please recheck and retry.')
        })
        .finally(() => {
          this.showLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer-to-account {
  height: 100%;
  padding: 0 40px;

  .custom-title {
    display: flex;
    align-items: center;
    background-color: rgb(249, 251, 252);
    padding: 30px 0;
    margin-top: 30px;

    .svg-icon {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 16px;
    }
  }
}

.transfer-button {
  margin-top: 300px;
  padding-bottom: 50px;
}

.note-title {
  font-size: 28px;
  color: #333;
  font-weight: 400;
  line-height: 28px;
  margin-top: 30px;
}

.md-field {
  padding: 0;
}

::v-deep .md-field-item-content::before {
  z-index: 1;
}

.error-message {
  color: red;
  font-size: 24px;
  height: 20px;
  margin-top: 20px;
}
</style>
